<template>
  <div class="customCode">
    <CodeType
      v-for="(type, idx) in types"
      :key="idx"
      :label="getLabel(type)"
      :type="type"
      :codeBase="codeBase[type]"
      :isLast="type === 'html'"
      />
  </div>
</template>

<script>
// components
import CodeType from './CodeType'
// services
import db from '@/services/db'

export default {
  components: {
    CodeType
  },
  data () {
    return {
      codeBase: {},
      types: ['css', 'js', 'html']
    }
  },
  methods: {
    getLabel (type) {
      let label = ''

      switch (type) {
        case 'css': label = 'CSS'
          break
        case 'js': label = 'JavaScript'
          break
        case 'html': label = 'HTML'
          break
      }

      return label
    }
  },
  created () {
    db.customCode.read((data) => {
      this.codeBase = {}
      if (data) this.codeBase = data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Toolbar/CustomCode/index.vue